import { render, staticRenderFns } from "./Straitigraphy.vue?vue&type=template&id=0e98faed&"
import script from "./Straitigraphy.vue?vue&type=script&lang=js&"
export * from "./Straitigraphy.vue?vue&type=script&lang=js&"
import style0 from "./Straitigraphy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports